import React, {
  useContext,
  useState,
  useRef,
  useEffect,
  Fragment,
  useCallback,
} from "react";
import "./App.css";
import axios, { AxiosResponse, AxiosError } from "axios";
import CodeMirror from "@uiw/react-codemirror";
import { createTheme } from "@uiw/codemirror-themes";
import { sql, SQLDialect } from "@codemirror/lang-sql";
import { EditorView, keymap } from "@codemirror/view";
import Split from "react-split";
import DataTable from "./DataTable"; // Import your DataTable component
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useParams,
} from "react-router-dom";
import Home from "./Home";
// const deepEqual = require('deep-equal');
// var deepEqual = require('fast-deep-equal');
import { BsListCheck } from "react-icons/bs";
import { BiLogoPostgresql } from "react-icons/bi";
import { SiPostgresql } from "react-icons/si";
import { ToastContainer, toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
import { IoArrowForward } from "react-icons/io5";
import { IoKey } from "react-icons/io5";
import { qs } from "qs";
import { RiHistoryLine } from "react-icons/ri";
import { FaKeyboard } from "react-icons/fa";
import Topbar from "./components/Topbar";
import "react-toastify/dist/ReactToastify.css";
import logo from "./logo_img.png";
import { AuthContext } from "./context/AuthContext";
import ProfessionalSQLEditor from "./ProfessionalSQLEditor";
import FlexibleChart from "./FlexibleChart";
import SchemaViewer from "./components/SchemaViewer";
import { autocompletion } from "@codemirror/autocomplete";
import { EditorState } from "@codemirror/state";
import { searchKeymap } from "@codemirror/search";
import { search } from "@codemirror/search";

function SubscribersMain() {
  const [sqlQuery, setSqlQuery] = useState("");
  const [results, setResults] = useState([]);
  const [correct, setCorrect] = useState("");
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState();
  const [queryerror, setQueryerror] = useState("");
  const { id } = useParams();
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 640);
  const [submissionResult, setSubmissionResult] = useState(null);
  const { userId, firstName } = useContext(AuthContext);
  const [isSolved, setIsSolved] = useState(false);
  const [viewMode, setViewMode] = useState("table"); // Add state for view mode
  const [cursorPosition, setCursorPosition] = useState({ line: 1, column: 1 });
  const [isEditorExpanded, setIsEditorExpanded] = useState(false);
  const [popoutPosition, setPopoutPosition] = useState({ x: 0, y: 0 });
  const [popoutSize, setPopoutSize] = useState({ width: 800, height: 600 });
  const dragRef = useRef(null);
  const resizeRef = useRef(null);
  const [showSchemaViewer, setShowSchemaViewer] = useState(false);
  const [schemaData, setSchemaData] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize from localStorage, default to false if not found
    const savedDarkMode = localStorage.getItem("sqlguru-dark-mode");
    return savedDarkMode ? JSON.parse(savedDarkMode) : false;
  });

  // Query History state
  const [queryHistory, setQueryHistory] = useState([]);
  const [showQueryHistory, setShowQueryHistory] = useState(false);
  const queryHistoryRef = useRef(null);
  const queryHistoryButtonRef = useRef(null);

  // Keyboard shortcuts state
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);
  const [isHoveringShortcuts, setIsHoveringShortcuts] = useState(false);
  const keyboardShortcutsRef = useRef(null);
  const keyboardShortcutsButtonRef = useRef(null);

  // Add state for button positions
  const [queryHistoryButtonPosition, setQueryHistoryButtonPosition] = useState({
    top: 0,
    right: 0,
  });
  const [shortcutsButtonPosition, setShortcutsButtonPosition] = useState({
    top: 0,
    right: 0,
  });

  // Function to calculate button position
  const calculateButtonPosition = (buttonRef) => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      return {
        top: rect.bottom + window.scrollY + 4, // 4px gap below button
        right: window.innerWidth - rect.right + window.scrollX, // Right align with button
      };
    }
    return { top: 0, right: 0 };
  };

  // Toggle query history with position calculation
  const toggleQueryHistory = () => {
    if (!showQueryHistory) {
      const position = calculateButtonPosition(queryHistoryButtonRef);
      setQueryHistoryButtonPosition(position);
    }
    setShowQueryHistory((prev) => !prev);
    setShowKeyboardShortcuts(false);
  };

  // Handle shortcuts hover with position calculation
  const handleShortcutsMouseEnter = () => {
    const position = calculateButtonPosition(keyboardShortcutsButtonRef);
    setShortcutsButtonPosition(position);
    setIsHoveringShortcuts(true);
    setShowQueryHistory(false);
  };

  const handleShortcutsMouseLeave = () => {
    setIsHoveringShortcuts(false);
  };

  const keyboardShortcuts = [
    {
      key: "Ctrl+Enter",
      macKey: "⌘+Enter",
      description: "Execute Query",
    },
    {
      key: "Ctrl+Shift+Enter",
      macKey: "⌘+Shift+Enter",
      description: "Submit Query",
    },
    {
      key: "Ctrl+F",
      macKey: "⌘+F",
      description: "Search in Editor",
    },
    {
      key: "Alt+F",
      macKey: "⌥+F",
      description: "Format SQL",
    },
    {
      key: "Alt+H",
      macKey: "⌥+H",
      description: "Toggle Query History",
    },
    {
      key: "Esc",
      macKey: "Esc",
      description: "Close Modals/Panels",
    },
  ];

  // Timer state
  const [time, setTime] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const timerRef = useRef(null);

  // Timer functions
  const startTimer = () => {
    if (!timerRunning) {
      setTimerRunning(true);
      timerRef.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
  };

  const pauseTimer = () => {
    if (timerRunning) {
      clearInterval(timerRef.current);
      setTimerRunning(false);
    }
  };

  const resetTimer = () => {
    clearInterval(timerRef.current);
    setTimerRunning(false);
    setTime(0);
  };

  // Format time for display (HH:MM:SS)
  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      seconds.toString().padStart(2, "0"),
    ].join(":");
  };

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 640);
    };

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount

  // const backendUrl = 'https://sqlguru-service.onrender.com';
  const backendUrl = "http://195.35.23.51:3001";

  // Remove localStorage code and first handleQueryChange
  // Replace with API-based query saving and loading
  // Function to handle query changes
  const handleQueryChange = (e) => {
    setSqlQuery(e);
    console.log("handleQueryChange - sqlQuery", sqlQuery);
  };

  // Debounced function to save query to database as user types
  useEffect(() => {
    // Only save if we have a userId, id, and sqlQuery
    if (userId && id && sqlQuery) {
      // Create a debounce timer to avoid too many API calls
      const timer = setTimeout(() => {
        saveQueryToDatabase(sqlQuery);
      }, 1000); // Wait 1 second after last keystroke before saving

      // Clear timeout if sqlQuery changes before timer expires
      return () => clearTimeout(timer);
    }
  }, [sqlQuery, userId, id]);

  // Function to save query to database
  const saveQueryToDatabase = async (query) => {
    try {
      await axios.post("https://sqlguroo.com/subapi/save-query", {
        userId,
        questionId: id,
        sqlQuery: query,
      });
      console.log("Query saved to database");
    } catch (error) {
      console.error("Failed to save query:", error);
      // Fallback to localStorage if API call fails
      const queryKey = `sqlQuery_${userId}_${id}`;
      localStorage.setItem(queryKey, query);
    }
  };

  // Load saved query from database when component mounts
  useEffect(() => {
    async function loadSavedQuery() {
      if (userId && id) {
        try {
          const response = await axios.get(
            "https://sqlguroo.com/subapi/get-saved-query",
            {
              params: {
                userId,
                questionId: id,
              },
            }
          );

          if (response.data.success && response.data.found) {
            setSqlQuery(response.data.sqlQuery);
          } else {
            // Check localStorage as fallback
            const queryKey = `sqlQuery_${userId}_${id}`;
            const savedQuery = localStorage.getItem(queryKey);
            if (savedQuery) {
              setSqlQuery(savedQuery);
              // Also save to database for future use
              saveQueryToDatabase(savedQuery);
            } else if (question && question.table_name1) {
              // Create a placeholder query using the question's table name
              let tableName = question.table_name1;
              // Check if it has the "table name - [actual_name]:" format
              if (tableName && tableName.includes("-")) {
                // Try to extract the table name
                const match = tableName.match(/- ([^:]+):/);
                if (match && match[1]) {
                  // Use just the extracted table name
                  tableName = match[1].trim();
                } else {
                  // Fallback: strip any "table name - " prefix and any trailing colon
                  tableName = tableName
                    .replace(/^table name - /i, "")
                    .replace(/:$/, "")
                    .trim();
                }
              }
              const placeholderQuery = `SELECT *\nFROM ${tableName}\nLIMIT 10;`;
              setSqlQuery(placeholderQuery);
              // Don't save the placeholder to the database
            }
          }
        } catch (error) {
          console.error("Failed to load saved query:", error);
          // Fallback to localStorage
          const queryKey = `sqlQuery_${userId}_${id}`;
          const savedQuery = localStorage.getItem(queryKey);
          if (savedQuery) {
            setSqlQuery(savedQuery);
          } else if (question && question.table_name1) {
            // Create a placeholder query using the question's table name
            let tableName = question.table_name1;
            // Check if it has the "table name - [actual_name]:" format
            if (tableName && tableName.includes("-")) {
              // Try to extract the table name
              const match = tableName.match(/- ([^:]+):/);
              if (match && match[1]) {
                // Use just the extracted table name
                tableName = match[1].trim();
              } else {
                // Fallback: strip any "table name - " prefix and any trailing colon
                tableName = tableName
                  .replace(/^table name - /i, "")
                  .replace(/:$/, "")
                  .trim();
              }
            }
            const placeholderQuery = `SELECT *\nFROM ${tableName}\nLIMIT 10;`;
            setSqlQuery(placeholderQuery);
            // Don't save the placeholder to the database
          }
        }
      }
    }

    loadSavedQuery();
  }, [userId, id, question]);

  const getItemData = async () => {
    try {
      const response = await axios.get(
        `https://sqlguroo.com/api/get-question/${id}`
      );
      const specificData = response.data;
      setQuestion(specificData);
      console.log(specificData);
    } catch (error) {
      console.error("Error fetching question data:", error);
    }
  };

  const executeQuery = async (e) => {
    e.preventDefault(); // Prevent default button behavior

    // Reset previous state
    setLoading(true);
    setQueryerror("");
    setButtonDisabled(true);
    setResults(null);
    setSubmissionResult(null);

    // Sanitization timeout
    const sanitizationDelay = 1400;

    setTimeout(async () => {
      console.log("sqlQuery", sqlQuery);

      try {
        // Configurable API endpoint
        const response = await axios.post(
          "https://sqlguroo.com/subapi/submit-text",
          { sqlQuery },
          {
            timeout: 15000, // 5 seconds timeout
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("response from executeQuery", response);

        // Successful query execution
        setLoading(false);
        setResults(response.data);
        setQueryerror("");

        // Save query to history if it's not empty and not already in history
        if (
          sqlQuery.trim() &&
          !queryHistory.some((item) => item.query === sqlQuery)
        ) {
          // Add timestamp and limit history to last 20 queries
          const newHistoryItem = {
            query: sqlQuery,
            timestamp: new Date(),
            successful: true,
          };
          setQueryHistory((prev) => [newHistoryItem, ...prev].slice(0, 20));
        }
      } catch (error) {
        console.log("error in executeQuery", error);
        // Comprehensive error handling
        if (axios.isCancel(error)) {
          // Request cancellation
          setQueryerror("Request was cancelled");
        } else if (error.response) {
          // Server responded with an error
          setQueryerror(
            error.response.data.message ||
              error.response.data.error ||
              error.response.data ||
              "An error occurred while executing the query"
          );
        } else if (error.request) {
          // Request made but no response received
          setQueryerror("No response received from server");
        } else {
          // General error
          setQueryerror("An unexpected error occurred");
        }

        // Save failed query to history
        if (
          sqlQuery.trim() &&
          !queryHistory.some((item) => item.query === sqlQuery)
        ) {
          const newHistoryItem = {
            query: sqlQuery,
            timestamp: new Date(),
            successful: false,
            error:
              error.response?.data?.message || error.message || "Unknown Error",
          };
          setQueryHistory((prev) => [newHistoryItem, ...prev].slice(0, 20));
        }

        // Reset results
        setResults(null);
      } finally {
        // Always enable button after request
        setButtonDisabled(false);
      }
    }, sanitizationDelay);
  };

  // Add new submit function
  const submitQuery = async (e) => {
    e.preventDefault();
    // setIsSubmitting(true);
    setButtonDisabled(true);
    setSubmissionResult(null);
    setQueryerror("");

    try {
      const response = await axios.post(
        "https://sqlguroo.com/subapi/submit-solution",
        {
          sqlQuery,
          questionId: id, // Make sure you have access to the question ID,
          userId,
        },
        {
          timeout: 15000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSubmissionResult(response.data);
      console.log("submissionResult", response.data);

      // Handle success feedback
      if (response.data.isCorrect) {
        // Maybe trigger confetti or some celebration
        setQueryerror("");
      } else {
        setQueryerror("Your solution is not correct. Try again!");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setQueryerror(
        error.response?.data?.error ||
          "An error occurred while submitting your solution"
      );
    } finally {
      // setIsSubmitting(false);
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    getItemData();
  }, [id]);

  // Add this function to check solved status
  const checkSolvedStatus = async () => {
    try {
      const response = await axios.get(
        "https://sqlguroo.com/subapi/check-solved",
        {
          params: {
            questionId: id,
            userId: userId,
          },
        }
      );
      console.log("response from checkSolvedStatus", response);
      setIsSolved(response.data.isSolved);
    } catch (error) {
      console.error("Error checking solved status:", error);
    }
  };

  // Call this in useEffect when question loads
  useEffect(() => {
    if (id && userId) {
      checkSolvedStatus();
    }
  }, [id, userId]);

  const KEYWORDS = [
    "select",
    "from",
    "where",
    "and",
    "or",
    "not",
    "in",
    "between",
    "contains",
    "array",
    "limit",
    "offset",
    "union",
    "intersect",
    "except",
    "order by",
    "asc",
    "desc",
  ];

  const TENSORS = ["images", "labels"];

  const dialect = SQLDialect.define({
    keywords: KEYWORDS.join(" "),
    builtin: TENSORS.join(" "),
  });

  const sampleData = [
    { month: 1, sales: 100 },
    { month: 2, sales: 150 },
    { month: 3, sales: 120 },
  ];

  // Add new functions for format and clear
  const formatSQLQuery = () => {
    if (!sqlQuery.trim()) return;

    let formattedQuery = sqlQuery
      // Replace multiple spaces with single space
      .replace(/\s+/g, " ")
      // Add newline after comma followed by a word
      .replace(/,(\w)/g, ",\n$1")
      // Add newline and indent before major SQL clauses
      .replace(
        /\b(SELECT|FROM|WHERE|GROUP BY|HAVING|ORDER BY|LIMIT|OFFSET|JOIN|LEFT JOIN|RIGHT JOIN|INNER JOIN|OUTER JOIN|AND|OR)\b/gi,
        "\n$1"
      )
      .trim();

    // Add proper indentation
    let lines = formattedQuery.split("\n");
    let indentLevel = 0;
    formattedQuery = lines
      .map((line) => {
        line = line.trim();
        // Decrease indent for closing parentheses
        if (line.startsWith(")")) indentLevel = Math.max(0, indentLevel - 1);
        // Add current indentation
        const indentedLine = "    ".repeat(indentLevel) + line;
        // Increase indent for opening parentheses
        if (line.includes("(")) indentLevel++;
        return indentedLine;
      })
      .join("\n");

    setSqlQuery(formattedQuery);
  };

  const clearSQLQuery = () => {
    setSqlQuery("");
  };

  // Load a query from history
  const loadQueryFromHistory = (historyItem) => {
    setSqlQuery(historyItem.query);
    setShowQueryHistory(false);
  };

  // Add search panel toggle function
  const toggleSearch = useCallback(() => {
    setIsSearchOpen((prev) => !prev);
  }, []);

  // Add search panel state
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // Add search shortcut
  const searchShortcut = keymap.of([
    {
      key: "Ctrl-f",
      run: toggleSearch,
      preventDefault: true,
    },
  ]);

  // Add cursor position tracking extension
  const cursorPositionExtension = EditorView.updateListener.of((update) => {
    if (update.docChanged || update.selectionSet) {
      const pos = update.state.selection.main.head;
      const line = update.state.doc.lineAt(pos);
      setCursorPosition({
        line: line.number,
        column: pos - line.from + 1,
      });
    }
  });

  // Editor expansion handlers
  const handleEditorExpand = () => {
    if (!isEditorExpanded) {
      // Set initial position to center of screen
      const centerX = (window.innerWidth - popoutSize.width) / 2;
      const centerY = (window.innerHeight - popoutSize.height) / 2;
      setPopoutPosition({ x: Math.max(0, centerX), y: Math.max(0, centerY) });
    }
    setIsEditorExpanded(!isEditorExpanded);
  };

  // Add window dragging functionality
  const handleDragStart = useCallback(
    (e) => {
      const startX = e.clientX - popoutPosition.x;
      const startY = e.clientY - popoutPosition.y;

      const handleDrag = (e) => {
        setPopoutPosition({
          x: e.clientX - startX,
          y: e.clientY - startY,
        });
      };

      const handleDragEnd = () => {
        document.removeEventListener("mousemove", handleDrag);
        document.removeEventListener("mouseup", handleDragEnd);
      };

      document.addEventListener("mousemove", handleDrag);
      document.addEventListener("mouseup", handleDragEnd);
    },
    [popoutPosition]
  );

  // Add this function to process schema data
  const processSchemaData = useCallback(() => {
    if (!question) return null;

    console.log("Processing schema data:", question);

    const tables = [];
    const relationships = [];

    // Helper function to process columns and detect relationships
    const processColumns = (schema, tableName) => {
      if (!schema || !Array.isArray(schema)) return [];

      return schema.map((col) => {
        // Log the raw column data to see its structure
        console.log("Raw column data:", col);

        // Get column name
        const name =
          col.Field ||
          col.field ||
          col.FIELD ||
          col.Column ||
          col.column ||
          col.COLUMN ||
          col.column_name ||
          col.COLUMN_NAME ||
          Object.keys(col)[0];

        // Get column type
        const type =
          col.Type ||
          col.type ||
          col.TYPE ||
          col.data_type ||
          col.DATA_TYPE ||
          Object.values(col)[0];

        // Check for primary and foreign keys
        const isPrimaryKey =
          col.Key === "PRI" ||
          col.key === "PRI" ||
          col.is_primary_key === "YES" ||
          col.isPrimary === true;
        const isForeignKey =
          col.Key === "MUL" ||
          col.key === "MUL" ||
          col.is_foreign_key === "YES" ||
          col.isForeign === true;

        // If this is a foreign key and has reference information, add to relationships
        if (isForeignKey && col.references_table) {
          relationships.push({
            source: tableName,
            sourceColumn: name,
            target: col.references_table,
            targetColumn: col.references_column || "id", // Default to 'id' if not specified
            type: "foreign_key",
          });
        }

        return {
          name: name || "Unknown Field",
          type: type || "Unknown Type",
          isPrimaryKey,
          isForeignKey,
          references: col.references_table
            ? {
                table: col.references_table,
                column: col.references_column || "id",
              }
            : null,
        };
      });
    };

    // Process main schema
    if (question.schema) {
      const tableName =
        question.table_schema1 || question.table_name1 || "Main Table";
      const mainTable = {
        name: tableName,
        columns: processColumns(question.schema, tableName),
      };
      tables.push(mainTable);
    }

    // Process second schema
    if (question.schema2) {
      const tableName =
        question.table_schema2 || question.table_name2 || "Second Table";
      const secondTable = {
        name: tableName,
        columns: processColumns(question.schema2, tableName),
      };
      tables.push(secondTable);
    }

    // Process third schema
    if (question.schema3) {
      const tableName =
        question.table_schema3 || question.table_name3 || "Third Table";
      const thirdTable = {
        name: tableName,
        columns: processColumns(question.schema3, tableName),
      };
      tables.push(thirdTable);
    }

    // Add implicit relationships based on naming conventions
    tables.forEach((table) => {
      table.columns.forEach((column) => {
        // Look for columns that might be foreign keys based on naming (e.g., user_id)
        if (column.name.toLowerCase().endsWith("_id") && !column.isForeignKey) {
          const possibleTableName = column.name
            .toLowerCase()
            .replace("_id", "");
          const referencedTable = tables.find(
            (t) =>
              t.name.toLowerCase() === possibleTableName ||
              t.name.toLowerCase() === possibleTableName + "s" // Handle plural forms
          );

          if (referencedTable) {
            const primaryKeyColumn = referencedTable.columns.find(
              (c) => c.isPrimaryKey
            );
            if (primaryKeyColumn) {
              relationships.push({
                source: table.name,
                sourceColumn: column.name,
                target: referencedTable.name,
                targetColumn: primaryKeyColumn.name,
                type: "implicit",
              });
              column.isForeignKey = true;
              column.references = {
                table: referencedTable.name,
                column: primaryKeyColumn.name,
              };
            }
          }
        }
      });
    });

    console.log("Processed tables and relationships:", {
      tables,
      relationships,
    });
    return { tables, relationships };
  }, [question]);

  useEffect(() => {
    const data = processSchemaData();
    setSchemaData(data);
  }, [question, processSchemaData]);

  // Add keyboard shortcut effect
  useEffect(() => {
    const handleKeyDown = (e) => {
      // For debugging
      console.log(
        "Key pressed:",
        e.key,
        "Alt:",
        e.altKey,
        "Ctrl:",
        e.ctrlKey,
        "Meta:",
        e.metaKey,
        "Code:",
        e.code
      );

      const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

      // Execute query: Ctrl+Enter (Windows) or Command+Enter (Mac)
      if (
        (isMac && e.metaKey && e.key === "Enter" && !e.shiftKey) ||
        (!isMac && e.ctrlKey && e.key === "Enter" && !e.shiftKey)
      ) {
        e.preventDefault();
        if (!isButtonDisabled) {
          executeQuery(e);
        }
      }

      // Submit query: Ctrl+Shift+Enter (Windows) or Command+Shift+Enter (Mac)
      if (
        (isMac && e.metaKey && e.shiftKey && e.key === "Enter") ||
        (!isMac && e.ctrlKey && e.shiftKey && e.key === "Enter")
      ) {
        e.preventDefault();
        if (!isButtonDisabled) {
          submitQuery(e);
        }
      }

      // Format SQL: Alt+F
      if (e.altKey && e.code === "KeyF") {
        e.preventDefault();
        formatSQLQuery();
      }

      // Toggle query history: Alt+H
      if (e.altKey && e.code === "KeyH") {
        e.preventDefault();
        toggleQueryHistory();
      }

      // Close modals/panels: Esc
      if (e.key === "Escape") {
        setShowQueryHistory(false);
        setShowKeyboardShortcuts(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isButtonDisabled, sqlQuery]);

  // Add click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      // Close query history if clicked outside
      if (
        showQueryHistory &&
        queryHistoryRef.current &&
        queryHistoryButtonRef.current &&
        !queryHistoryRef.current.contains(event.target) &&
        !queryHistoryButtonRef.current.contains(event.target)
      ) {
        setShowQueryHistory(false);
      }
    }

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showQueryHistory]);

  // Add this function to ensure window stays within viewport
  const ensureWindowInBounds = (x, y, width, height) => {
    const maxX = window.innerWidth - width;
    const maxY = window.innerHeight - height;
    return {
      x: Math.max(0, Math.min(x, maxX)),
      y: Math.max(0, Math.min(y, maxY)),
    };
  };

  // Add window resizing functionality
  const handleResizeStart = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = popoutSize.width;
    const startHeight = popoutSize.height;

    const handleResize = (e) => {
      const newWidth = Math.max(
        400,
        Math.min(window.innerWidth * 0.95, startWidth + (e.clientX - startX))
      );
      const newHeight = Math.max(
        300,
        Math.min(window.innerHeight * 0.95, startHeight + (e.clientY - startY))
      );

      // Adjust position if needed to keep window in bounds
      const adjustedPosition = ensureWindowInBounds(
        popoutPosition.x,
        popoutPosition.y,
        newWidth,
        newHeight
      );

      setPopoutSize({ width: newWidth, height: newHeight });
      setPopoutPosition(adjustedPosition);
    };

    const handleResizeEnd = () => {
      document.removeEventListener("mousemove", handleResize);
      document.removeEventListener("mouseup", handleResizeEnd);
    };

    document.addEventListener("mousemove", handleResize);
    document.addEventListener("mouseup", handleResizeEnd);
  };

  // Helper function to process schema data for visualization

  // Effect to save dark mode preference to localStorage
  useEffect(() => {
    localStorage.setItem("sqlguru-dark-mode", JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  return (
    <div
      className={`relative flex h-screen overflow-hidden justify-center ${
        isDarkMode ? "bg-gray-900" : "bg-white"
      }`}
      data-theme={isDarkMode ? "dark" : "light"}
    >
      <div
        className={`relative flex flex-col 
                    w-full 
                    max-w-[98%]            /* Default max width */
                    
                    2xl:max-w-[1820px]     /* 2XL screens */
                    mx-auto 
                    h-screen 
                    overflow-hidden ${isDarkMode ? "bg-gray-900" : ""}`}
      >
        <Topbar
          isDarkMode={isDarkMode}
          setIsDarkMode={setIsDarkMode}
          showDarkModeToggle={true}
        />

        <Split
          // class="wrap"
          sizes={[40, 60]}
          minSize={100}
          expandToMin={false}
          gutterSize={10}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
          className="split flex flex-row overflow-hidden h-full"
        >
          <div
            className={`border ${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            } rounded-md shadow-sm p-1 overflow-auto`}
          >
            <div className="flex flex-row justify-between items-center gap-1 sm:gap-2 p-1 sm:p-2 overflow-auto">
              {/* All Questions Button */}
              <Link to="/questionsoverview">
                <button
                  type="button"
                  className={`inline-flex items-center justify-center gap-0.5 px-1 py-0.5 sm:px-1.5 sm:py-1 ${
                    isDarkMode
                      ? "bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 text-gray-200 border-gray-600"
                      : "bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-700 border-gray-200"
                  } rounded-md transition-all duration-300 shadow-sm hover:shadow-md text-[11px] sm:text-xs border min-w-[28px] sm:min-w-[36px] wide:min-w-[100px]`}
                >
                  <BsListCheck
                    className={`text-xs sm:text-sm ${
                      isDarkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  />
                  <span className="hidden wide:inline">Questions</span>
                </button>
              </Link>

              {/* Solution Button */}
              <button
                onClick={() =>
                  document.getElementById("my_modal_2").showModal()
                }
                className="inline-flex items-center justify-center gap-0.5 px-1 py-0.5 sm:px-1.5 sm:py-1 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-md transition-all duration-300 shadow-sm hover:shadow-md text-[11px] sm:text-xs transform hover:scale-105 min-w-[28px] sm:min-w-[36px] wide:min-w-[100px]"
              >
                <IoKey className="text-xs sm:text-sm" />
                <span className="hidden wide:inline">Solution</span>
              </button>

              {/* Solution Modal */}
              <dialog
                id="my_modal_2"
                className="modal"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    document.getElementById("my_modal_2").close();
                  }
                }}
              >
                <div className="modal-box max-w-6xl w-[95vw] h-[80vh] bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-100 relative">
                  {/* Toast notification that appears when copied */}
                  <div
                    id="copy-toast"
                    className="hidden absolute top-20 right-8 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg z-50 transition-opacity duration-300 flex items-center gap-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-green-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Solution copied to clipboard
                  </div>

                  {/* Header with gradient background */}
                  <div className="bg-gradient-to-r from-indigo-700 via-blue-600 to-sky-500 p-6 relative">
                    <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]"></div>
                    <div className="flex items-center justify-between relative z-10">
                      <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-7 w-7"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                          />
                        </svg>
                        SQL Solution
                      </h3>
                      <form method="dialog">
                        <button className="btn btn-sm btn-circle bg-white/20 border-0 text-white hover:bg-white/30 backdrop-blur-sm">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </form>
                    </div>
                  </div>

                  {/* Content area with better spacing */}
                  <div className="p-8 flex flex-col h-[calc(80vh-88px)]">
                    <div className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 shadow-lg flex-grow flex flex-col">
                      {/* Code editor header */}
                      <div className="flex items-center justify-between bg-gray-800 px-4 py-3 border-b border-gray-700">
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-gray-300">
                            SQL Query
                          </span>
                          <span className="px-2 py-0.5 text-xs bg-blue-600 text-white rounded-full">
                            Solution
                          </span>
                        </div>
                      </div>

                      {/* Code editor with flexible height */}
                      <div className="flex-grow overflow-hidden">
                        <CodeMirror
                          className="h-full overflow-auto"
                          extensions={[
                            sql({ dialect }),
                            EditorView.lineWrapping,
                            autocompletion({
                              activateOnTyping: true,
                              maxRenderedOptions: 8,
                              defaultKeymap: true,
                              icons: false,
                            }),
                            cursorPositionExtension,
                            search({
                              top: true,
                              caseSensitive: true,
                            }),
                            searchShortcut,
                          ]}
                          value={question ? question.solution : ""}
                          options={{ readOnly: true }}
                          theme="dark"
                        />
                      </div>
                    </div>

                    {/* Footer with action buttons */}
                    <div className="mt-6 flex justify-end gap-3">
                      <button
                        onClick={() =>
                          document.getElementById("my_modal_2").close()
                        }
                        className="px-5 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition-colors"
                      >
                        Close
                      </button>
                      <button
                        onClick={() => {
                          if (question && question.solution) {
                            navigator.clipboard
                              .writeText(question.solution)
                              .then(() => {
                                // Show toast notification
                                const toast =
                                  document.getElementById("copy-toast");
                                toast.classList.remove("hidden");
                                toast.classList.add("flex");

                                // Hide toast after 3 seconds
                                setTimeout(() => {
                                  toast.classList.add("opacity-0");
                                  setTimeout(() => {
                                    toast.classList.remove("flex", "opacity-0");
                                    toast.classList.add("hidden");
                                  }, 300);
                                }, 3000);
                              })
                              .catch((err) => {
                                console.error("Failed to copy: ", err);
                              });
                          }
                        }}
                        className="px-5 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium rounded-lg transition-all duration-200 shadow-md hover:shadow-lg flex items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                          />
                        </svg>
                        Copy Solution
                      </button>
                    </div>
                  </div>
                </div>
              </dialog>

              {/* Case Study Button */}
              <button
                onClick={() =>
                  document.getElementById("my_modal_4").showModal()
                }
                className="group relative inline-flex items-center justify-center gap-0.5 px-1 py-0.5 sm:px-1.5 sm:py-1 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white rounded-md transition-all duration-300 shadow-sm hover:shadow-md text-[11px] sm:text-xs transform hover:scale-105 min-w-[28px] sm:min-w-[36px] wide:min-w-[100px]"
              >
                <svg
                  className="w-2.5 h-2.5 sm:w-3 sm:h-3 transition-transform group-hover:rotate-12 duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <span className="hidden wide:inline">Case</span>
              </button>

              {/* Case study Modal */}
              <dialog
                id="my_modal_4"
                className="modal"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    document.getElementById("my_modal_4").close();
                  }
                }}
              >
                <div className="modal-box max-w-4xl bg-white rounded-lg shadow-2xl">
                  {/* Header Section */}
                  <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 rounded-t-lg">
                    <div className="flex justify-between items-center">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2">
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                          />
                        </svg>
                        Context of this Case Study
                      </h3>
                      <button
                        onClick={() =>
                          document.getElementById("my_modal_4").close()
                        }
                        className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 bg-gray-400 text-white hover:bg-blue-600"
                      >
                        ✕
                      </button>
                    </div>
                  </div>

                  {/* Image Section */}
                  <div className="p-6 border-b border-gray-200">
                    <div className="w-full h-48 md:h-64 lg:h-80 rounded-lg overflow-hidden bg-gray-100">
                      {question?.image_url ? (
                        <img
                          src={question.image_url}
                          alt="Case Study Diagram"
                          className="w-full h-full object-contain"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "path/to/fallback/image.png"; // Add a fallback image path
                          }}
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-400">
                          <svg
                            className="w-12 h-12"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-6">
                    <div className="bg-gray-50 p-5 rounded-lg border border-gray-100 shadow-inner">
                      <p className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap">
                        {question ? question.case_study : "Loading question..."}
                      </p>
                    </div>

                    {/* Footer Section */}
                    <div className="mt-6 flex justify-end gap-3">
                      <button
                        onClick={() =>
                          document.getElementById("my_modal_4").close()
                        }
                        className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg transition-colors flex items-center gap-2"
                      >
                        Let's Go!
                      </button>
                    </div>
                  </div>
                </div>
              </dialog>

              {/* PostgreSQL Syntax Button */}
              <button
                onClick={() =>
                  document.getElementById("my_modal_3").showModal()
                }
                className="inline-flex items-center justify-center gap-0.5 px-1 py-0.5 sm:px-1.5 sm:py-1 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-md transition-all duration-300 shadow-sm hover:shadow-md text-[11px] sm:text-xs transform hover:scale-105 min-w-[28px] sm:min-w-[36px] wide:min-w-[100px]"
              >
                <SiPostgresql className="text-xs sm:text-sm" />
                <span className="hidden wide:inline">Syntax</span>
              </button>

              {/* PostgreSQL Syntax Modal */}
              <dialog
                id="my_modal_3"
                className="modal"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    document.getElementById("my_modal_3").close();
                  }
                }}
              >
                <div
                  className="modal-box max-w-5xl bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex items-center justify-between bg-blue-600 px-6 py-4">
                    <div className="flex items-center gap-3">
                      <SiPostgresql className="text-white text-2xl" />
                      <h3 className="text-xl font-semibold text-white">
                        PostgreSQL Syntax Guide
                      </h3>
                    </div>
                    <form method="dialog">
                      <button className="btn btn-sm btn-circle bg-white/20 hover:bg-white/30 border-0 text-white">
                        ✕
                      </button>
                    </form>
                  </div>

                  <div className="p-4 overflow-y-auto max-h-[75vh]">
                    <p className="text-gray-600 mb-3 text-sm">
                      Quick reference for commonly used PostgreSQL syntax. Hover
                      over examples for more details.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Basic SELECT Structure */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Basic SELECT Structure
                          </h4>
                        </div>
                        <div className="p-3">
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`SELECT column1, column2
FROM table_name
WHERE condition
GROUP BY column1
HAVING condition
ORDER BY column1 [ASC|DESC]
LIMIT n;`}
                          </pre>
                        </div>
                      </div>

                      {/* Date/Time Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Date/Time Functions
                          </h4>
                        </div>
                        <div className="p-3">
                          <p className="mb-1 text-xs text-gray-600">
                            Date comparison:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 mb-2 whitespace-pre-wrap">
                            {`date_column = DATE '2020-01-01'`}
                          </pre>
                          <p className="mb-1 text-xs text-gray-600">
                            Extract parts:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`EXTRACT(MONTH FROM date_column)
EXTRACT(YEAR FROM date_column)
EXTRACT(DOW FROM date_column)`}
                          </pre>
                        </div>
                      </div>

                      {/* Aggregation Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Aggregation Functions
                          </h4>
                        </div>
                        <div className="p-3">
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`COUNT(*) -- count rows
SUM(column) -- sum values
AVG(column) -- average
MIN(column) -- minimum value
MAX(column) -- maximum value`}
                          </pre>
                        </div>
                      </div>

                      {/* JOIN Types */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">JOIN Types</h4>
                        </div>
                        <div className="p-3">
                          <p className="mb-1 text-xs text-gray-600">
                            Inner join (default):
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 mb-2 whitespace-pre-wrap">
                            {`FROM table1 JOIN table2
ON table1.column = table2.column`}
                          </pre>
                          <p className="mb-1 text-xs text-gray-600">
                            Left join keeps all rows from table1:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`FROM table1 LEFT JOIN table2
ON table1.column = table2.column`}
                          </pre>
                        </div>
                      </div>

                      {/* Window Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Window Functions
                          </h4>
                        </div>
                        <div className="p-3">
                          <p className="mb-1 text-xs text-gray-600">
                            Rank products by price within category:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`SELECT product_name, category, price,
RANK() OVER (
  PARTITION BY category
  ORDER BY price DESC
) as price_rank
FROM products;`}
                          </pre>
                        </div>
                      </div>

                      {/* Common Table Expressions (WITH) */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Common Table Expressions (WITH)
                          </h4>
                        </div>
                        <div className="p-3">
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`WITH high_value_customers AS (
  SELECT customer_id, SUM(total) as total_spent
  FROM orders
  GROUP BY customer_id
  HAVING SUM(total) > 1000
)
SELECT c.name, hvc.total_spent
FROM customers c
JOIN high_value_customers hvc 
  ON c.id = hvc.customer_id
ORDER BY hvc.total_spent DESC;`}
                          </pre>
                        </div>
                      </div>

                      {/* String Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            String Functions
                          </h4>
                        </div>
                        <div className="p-3">
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`LOWER(string) -- convert to lowercase
UPPER(string) -- convert to uppercase
LENGTH(string) -- string length
SUBSTRING(string, start, length)
CONCAT(string1, string2, ...)
REPLACE(string, from, to)`}
                          </pre>
                        </div>
                      </div>

                      {/* Data Type Conversion */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                            />
                          </svg>
                          <h4 className="font-medium text-sm">
                            Data Type Conversion
                          </h4>
                        </div>
                        <div className="p-3">
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`-- Two equivalent methods:
CAST(expression AS type)
expression::type

-- Examples:
CAST(price AS integer)
order_date::date
amount::numeric(10,2)`}
                          </pre>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 px-5 py-3 flex justify-end border-t border-gray-200">
                    <form method="dialog">
                      <button className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-md transition-colors">
                        Close Reference
                      </button>
                    </form>
                  </div>
                </div>
              </dialog>

              {/* Schema Viewer Button */}
              <button
                onClick={() => setShowSchemaViewer(true)}
                className="inline-flex items-center justify-center gap-0.5 px-1 py-0.5 sm:px-1.5 sm:py-1 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white rounded-md transition-all duration-300 shadow-sm hover:shadow-md text-[11px] sm:text-xs transform hover:scale-105 min-w-[28px] sm:min-w-[36px] wide:min-w-[100px]"
              >
                <svg
                  className="w-2.5 h-2.5 sm:w-3 sm:h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                  />
                </svg>
                <span className="hidden wide:inline">Schema</span>
              </button>

              {/* Dark Mode Toggle Button */}
            </div>

            <div
              className={`max-w-6xl mx-auto p-1 ${
                isDarkMode ? "bg-gray-800" : "bg-white"
              } rounded-lg shadow-sm`}
            >
              {/* Question Section */}
              <div className="mb-4 sm:mb-6 space-y-1 sm:space-y-2">
                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                      : "bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200"
                  } rounded-lg p-2 sm:p-4 border`}
                >
                  <div className="flex items-center justify-between mb-1 sm:mb-2">
                    <p
                      className={`text-base sm:text-lg font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-gray-800"
                      }`}
                    >
                      {id}. - {question ? question.question : ""}
                    </p>
                  </div>
                  <div
                    className={`prose max-w-none ${
                      isDarkMode ? "text-gray-300" : "text-gray-600"
                    } text-sm sm:text-base`}
                  >
                    {question ? question.html : ""}
                  </div>
                </div>
              </div>

              {/* Schema Section */}
              <div className="mb-6">
                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-blue-600 to-blue-700"
                      : "bg-gradient-to-r from-blue-500 to-blue-600"
                  } rounded-lg px-3 py-1.5 sm:px-4 sm:py-2 mb-2 sm:mb-3 shadow-sm`}
                >
                  <h2 className="text-sm sm:text-base font-semibold text-white text-center flex items-center justify-center gap-1 sm:gap-2">
                    <svg
                      className="w-4 h-4 sm:w-5 sm:h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                      />
                    </svg>
                    Schema Information
                  </h2>
                </div>
                <div className="space-y-4">
                  {/* First Schema */}
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                        : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                    } p-3 rounded-lg border`}
                  >
                    <div
                      className={`${
                        isDarkMode
                          ? "bg-blue-900 border-blue-600"
                          : "bg-blue-50 border-blue-500"
                      } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                    >
                      <h3
                        className={`text-sm font-medium ${
                          isDarkMode ? "text-blue-300" : "text-blue-700"
                        } flex items-center gap-2`}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                        {question?.table_schema1 && question.table_schema1}
                      </h3>
                    </div>
                    <div
                      className={`${
                        isDarkMode ? "bg-gray-800" : "bg-white"
                      } rounded-lg shadow-sm`}
                    >
                      {question ? (
                        <DataTable
                          data={question.schema}
                          isDarkMode={isDarkMode}
                        />
                      ) : (
                        <span className="loading loading-infinity loading-lg"></span>
                      )}
                    </div>
                  </div>

                  {/* Second Schema */}
                  {question &&
                    question.hasOwnProperty("schema2") &&
                    question.schema2 && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                            : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                        } p-3 rounded-lg border`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-blue-900 border-blue-600"
                              : "bg-blue-50 border-blue-500"
                          } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                        >
                          <h3
                            className={`text-sm font-medium ${
                              isDarkMode ? "text-blue-300" : "text-blue-700"
                            } flex items-center gap-2`}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                              />
                            </svg>
                            {question.table_schema2}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode ? "bg-gray-800" : "bg-white"
                          } rounded-lg shadow-sm`}
                        >
                          <DataTable
                            data={question.schema2}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}

                  {/* Third Schema */}
                  {question &&
                    question.hasOwnProperty("schema3") &&
                    question.schema3 && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                            : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                        } p-3 rounded-lg border`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-blue-900 border-blue-600"
                              : "bg-blue-50 border-blue-500"
                          } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                        >
                          <h3
                            className={`text-sm font-medium ${
                              isDarkMode ? "text-blue-300" : "text-blue-700"
                            } flex items-center gap-2`}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                              />
                            </svg>
                            {question.table_schema3}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode ? "bg-gray-800" : "bg-white"
                          } rounded-lg shadow-sm`}
                        >
                          <DataTable
                            data={question.schema3}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>

              {/* Data Table Section */}
              <div className="mb-6">
                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-indigo-600 to-purple-700"
                      : "bg-gradient-to-r from-indigo-500 to-purple-600"
                  } rounded-lg px-4 py-2 mb-3 shadow-sm`}
                >
                  <h2 className="text-base font-semibold text-white text-center flex items-center justify-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                    Sample Data
                  </h2>
                </div>

                <div className="space-y-4">
                  {/* First Table */}
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                        : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                    } p-3 rounded-lg border`}
                  >
                    <div
                      className={`${
                        isDarkMode
                          ? "bg-indigo-900 border-indigo-600"
                          : "bg-indigo-50 border-indigo-500"
                      } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                    >
                      <h3
                        className={`text-sm font-medium ${
                          isDarkMode ? "text-indigo-300" : "text-indigo-700"
                        } flex items-center gap-2`}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                          />
                        </svg>
                        {question &&
                          question.hasOwnProperty("table_name1") &&
                          question.table_name1}
                      </h3>
                    </div>
                    <div
                      className={`${
                        isDarkMode ? "bg-gray-800" : "bg-white"
                      } rounded-lg shadow-sm`}
                    >
                      {question ? (
                        <DataTable
                          data={question.table}
                          isDarkMode={isDarkMode}
                        />
                      ) : (
                        <span className="loading loading-infinity loading-lg"></span>
                      )}
                    </div>
                  </div>

                  {/* Second Table */}
                  {question &&
                    question.hasOwnProperty("table2") &&
                    question.table2 && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                            : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                        } p-3 rounded-lg border`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-indigo-900 border-indigo-600"
                              : "bg-indigo-50 border-indigo-500"
                          } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                        >
                          <h3
                            className={`text-sm font-medium ${
                              isDarkMode ? "text-indigo-300" : "text-indigo-700"
                            } flex items-center gap-2`}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                              />
                            </svg>
                            {question.table_name2}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode ? "bg-gray-800" : "bg-white"
                          } rounded-lg shadow-sm`}
                        >
                          <DataTable
                            data={question.table2}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}

                  {/* Third Table */}
                  {question &&
                    question.hasOwnProperty("table3") &&
                    question.table3 && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                            : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                        } p-3 rounded-lg border`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-indigo-900 border-indigo-600"
                              : "bg-indigo-50 border-indigo-500"
                          } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                        >
                          <h3
                            className={`text-sm font-medium ${
                              isDarkMode ? "text-indigo-300" : "text-indigo-700"
                            } flex items-center gap-2`}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                              />
                            </svg>
                            {question.table_name3}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode ? "bg-gray-800" : "bg-white"
                          } rounded-lg shadow-sm`}
                        >
                          <DataTable
                            data={question.table3}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>

              {/* Example Output Section */}
              <div>
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg px-4 py-2 mb-3 shadow-sm">
                  <h2 className="text-base font-semibold text-white text-center flex items-center justify-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                      />
                    </svg>
                    Expected Output
                  </h2>
                </div>

                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                      : "bg-gradient-to-r from-gray-50 to-white border-gray-200"
                  } p-3 rounded-lg border`}
                >
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-emerald-900 border-emerald-600"
                        : "bg-emerald-50 border-emerald-500"
                    } border-l-4 rounded-md px-3 py-1.5 mb-2`}
                  >
                    <h3
                      className={`text-sm font-medium ${
                        isDarkMode ? "text-emerald-300" : "text-emerald-700"
                      } flex items-center gap-2`}
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                        />
                      </svg>
                      Result Format
                    </h3>
                  </div>
                  <div
                    className={`${
                      isDarkMode ? "bg-gray-800" : "bg-white"
                    } rounded-lg shadow-sm`}
                  >
                    {question ? (
                      <DataTable
                        data={question.example_output}
                        isDarkMode={isDarkMode}
                      />
                    ) : (
                      <span className="loading loading-infinity loading-lg"></span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`flex flex-col h-full ${
              isDarkMode ? "bg-gray-800" : "bg-gray-100"
            } p-1`}
          >
            {/* <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden"> */}
            <div
              className={`border ${
                isDarkMode
                  ? "border-gray-600 bg-gray-800"
                  : "border-gray-200 bg-white"
              } rounded-md shadow-sm p-1 h-full`}
            >
              <Split
                // class="wrap"
                sizes={[50, 50]}
                minSize={200}
                expandToMin={false}
                gutterSize={8}
                gutterAlign="center"
                snapOffset={30}
                dragInterval={1}
                direction="vertical"
                cursor="row-resize"
                className="overflow-hidden h-full"
              >
                {/* Top Section: SQL Editor */}
                {/* <div className="flex flex-col h-full"> */}
                <div
                  className={`border ${
                    isDarkMode
                      ? "border-gray-600 bg-gray-800"
                      : "border-gray-300 bg-white"
                  } rounded-md shadow-sm flex flex-col h-full`}
                >
                  {/* Modern Compact SQL Playground Header */}
                  <div
                    className={`flex items-center justify-between h-10 sm:h-12 px-2 sm:px-3 border-b ${
                      isDarkMode
                        ? "border-gray-600 bg-gray-800/90"
                        : "border-gray-200 bg-white/90"
                    } backdrop-blur-sm`}
                  >
                    <div className="flex items-center gap-2">
                      <div className="flex items-center">
                        <BiLogoPostgresql
                          className={`${
                            isDarkMode ? "text-blue-400" : "text-blue-500"
                          } text-lg sm:text-xl`}
                        />
                        <h2
                          className={`ml-1 text-sm sm:text-base font-medium ${
                            isDarkMode ? "text-gray-200" : "text-gray-800"
                          }`}
                        >
                          SQL Playground
                        </h2>
                      </div>
                      <div
                        className={`h-4 w-[1px] ${
                          isDarkMode ? "bg-gray-600" : "bg-gray-200"
                        } mx-0.5`}
                      ></div>
                      {isSolved && (
                        <span
                          className={`px-1.5 py-0.5 ${
                            isDarkMode
                              ? "bg-green-900 text-green-300 border-green-700"
                              : "bg-green-50 text-green-600 border-green-100"
                          } text-[10px] rounded-md border flex items-center`}
                        >
                          <span className="mr-0.5 text-[8px]">✓</span>Solved
                        </span>
                      )}

                      {/* Timer Display - Made Bigger */}
                      <div
                        className={`h-4 w-[1px] ${
                          isDarkMode ? "bg-gray-600" : "bg-gray-200"
                        } mx-0.5`}
                      ></div>
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div
                          className={`px-2.5 py-1 ${
                            isDarkMode
                              ? "bg-gray-700 border-gray-600"
                              : "bg-gray-50 border-gray-200"
                          } border rounded-md flex items-center gap-1.5 shadow-sm`}
                        >
                          <svg
                            className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <span
                            className={`text-xs sm:text-sm font-mono font-medium ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            {formatTime(time)}
                          </span>
                        </div>

                        {/* Timer Controls - Made Bigger */}
                        <div className="flex items-center gap-1.5">
                          {!timerRunning ? (
                            <button
                              onClick={startTimer}
                              className={`p-1.5 rounded-md ${
                                isDarkMode
                                  ? "bg-emerald-900 text-emerald-300 border-emerald-700 hover:bg-emerald-800"
                                  : "bg-emerald-50 text-emerald-600 border-emerald-200 hover:bg-emerald-100"
                              } border transition-colors`}
                              title="Start Timer"
                            >
                              <svg
                                className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M8 5v14l11-7z" />
                              </svg>
                            </button>
                          ) : (
                            <button
                              onClick={pauseTimer}
                              className={`p-1.5 rounded-md ${
                                isDarkMode
                                  ? "bg-amber-900 text-amber-300 border-amber-700 hover:bg-amber-800"
                                  : "bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-100"
                              } border transition-colors`}
                              title="Pause Timer"
                            >
                              <svg
                                className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                              </svg>
                            </button>
                          )}
                          <button
                            onClick={resetTimer}
                            className={`p-1.5 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600"
                                : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                            } border transition-colors`}
                            title="Reset Timer"
                          >
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <button
                          onClick={handleEditorExpand}
                          className={`px-2 py-1 ${
                            isDarkMode
                              ? "text-gray-300 hover:text-gray-100 bg-gray-700 hover:bg-gray-600 border-gray-600"
                              : "text-gray-600 hover:text-gray-800 bg-gray-50 hover:bg-gray-100 border-gray-200"
                          } rounded-md border transition-colors flex items-center gap-1.5`}
                          title={isEditorExpanded ? "Collapse" : "Expand"}
                        >
                          <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 8V4m0 0h4M4 4l5 5m11-2V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                            />
                          </svg>
                          <span className="text-xs hidden sm:inline">
                            Expand
                          </span>
                        </button>
                        <button
                          onClick={formatSQLQuery}
                          className={`px-2 py-1 ${
                            isDarkMode
                              ? "bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600 hover:border-gray-500"
                              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300"
                          } text-sm font-medium rounded-lg border transition-all duration-200 flex items-center gap-1.5`}
                        >
                          <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 6h16M4 12h16m-7 6h7"
                            />
                          </svg>
                          Format
                        </button>
                        <button
                          onClick={clearSQLQuery}
                          className={`px-2 py-1 ${
                            isDarkMode
                              ? "bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600 hover:border-gray-500"
                              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300"
                          } text-sm font-medium rounded-lg border transition-all duration-200 flex items-center gap-1.5`}
                        >
                          <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                          Clear
                        </button>

                        {/* Add space between buttons */}
                        <div className="w-2"></div>

                        {/* Query History Button */}
                        <div className="relative">
                          <button
                            ref={queryHistoryButtonRef}
                            onClick={toggleQueryHistory}
                            className={`inline-flex items-center justify-center w-8 h-8 ${
                              showQueryHistory
                                ? isDarkMode
                                  ? "bg-blue-900 text-blue-300 border-blue-700"
                                  : "bg-blue-100 text-blue-700 border-blue-200"
                                : isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                                : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                            } rounded-md transition-colors text-xs font-medium border`}
                            title="Query History (Alt+H / ⌥+H)"
                          >
                            <RiHistoryLine className="w-4 h-4" />
                          </button>
                        </div>

                        {/* Keyboard Shortcuts Button */}
                        <div className="relative">
                          <button
                            ref={keyboardShortcutsButtonRef}
                            onMouseEnter={handleShortcutsMouseEnter}
                            onMouseLeave={handleShortcutsMouseLeave}
                            className={`inline-flex items-center justify-center w-8 h-8 ${
                              isHoveringShortcuts
                                ? isDarkMode
                                  ? "bg-blue-900 text-blue-300 border-blue-700"
                                  : "bg-blue-100 text-blue-700 border-blue-200"
                                : isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                                : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                            } rounded-md transition-colors text-xs font-medium border`}
                            title="Keyboard Shortcuts"
                          >
                            <FaKeyboard className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Code Editor */}
                  <div
                    className={`flex-grow relative min-h-0 ${
                      isDarkMode
                        ? "bg-gradient-to-b from-gray-800 to-gray-700"
                        : "bg-gradient-to-b from-gray-50 to-white"
                    } flex flex-col`}
                  >
                    <CodeMirror
                      className="h-full overflow-auto"
                      value={sqlQuery}
                      onChange={handleQueryChange}
                      extensions={[sql({ dialect }), cursorPositionExtension]}
                      theme={isDarkMode ? "dark" : "light"}
                      basicSetup={{
                        lineNumbers: true,
                        highlightActiveLineGutter: true,
                        highlightSpecialChars: true,
                        foldGutter: true,
                        dropCursor: true,
                        allowMultipleSelections: true,
                        indentOnInput: true,
                        bracketMatching: true,
                        closeBrackets: true,
                        autocompletion: true,
                        rectangularSelection: true,
                        crosshairCursor: true,
                        highlightActiveLine: true,
                        highlightSelectionMatches: true,
                        closeBracketsKeymap: true,
                        defaultKeymap: true,
                        searchKeymap: true,
                        historyKeymap: true,
                        foldKeymap: true,
                        completionKeymap: true,
                        lintKeymap: true,
                      }}
                    />

                    {/* Status Bar */}
                    <div
                      className={`h-5 sm:h-6 ${
                        isDarkMode
                          ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                          : "bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200"
                      } border-t px-2 sm:px-4 flex items-center justify-between text-[10px] sm:text-xs ${
                        isDarkMode ? "text-gray-300" : "text-gray-600"
                      }`}
                    >
                      <div className="flex items-center space-x-2 sm:space-x-4">
                        <span className="flex items-center">
                          <svg
                            className={`w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                          SQL
                        </span>
                        <span className="flex items-center">
                          <svg
                            className={`w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 8h.001M7 8h.001M11 8h.001M15 8h.001M19 8h.001M3 12h.001M7 12h.001M11 12h.001M15 12h.001M19 12h.001M3 16h.001M7 16h.001M11 16h.001M15 16h.001M19 16h.001"
                            />
                          </svg>
                          UTF-8
                        </span>
                      </div>
                      <div className="flex items-center">
                        <span className="flex items-center">
                          <svg
                            className={`w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                          Ln {cursorPosition.line}, Col {cursorPosition.column}
                        </span>
                      </div>
                    </div>

                    {/* Expanded Editor Window */}
                    {isEditorExpanded && (
                      <div
                        className={`fixed z-50 ${
                          isDarkMode
                            ? "bg-gray-800 border-gray-600"
                            : "bg-white border-gray-200"
                        } rounded-lg shadow-xl border`}
                        style={{
                          left: popoutPosition.x,
                          top: popoutPosition.y,
                          width: popoutSize.width,
                          height: popoutSize.height,
                        }}
                      >
                        {/* Draggable Header */}
                        <div
                          ref={dragRef}
                          className={`${
                            isDarkMode
                              ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                              : "bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200"
                          } px-4 py-3 rounded-t-lg border-b cursor-move flex items-center justify-between`}
                          onMouseDown={handleDragStart}
                        >
                          <div className="flex items-center gap-2">
                            <BiLogoPostgresql
                              className={`text-xl ${
                                isDarkMode ? "text-blue-400" : "text-blue-500"
                              }`}
                            />
                            <span
                              className={`font-semibold ${
                                isDarkMode ? "text-gray-200" : "text-gray-700"
                              }`}
                            >
                              SQL Editor
                            </span>

                            {/* Timer Display in Expanded View */}
                            <div
                              className={`h-4 w-[1px] ${
                                isDarkMode ? "bg-gray-600" : "bg-gray-200"
                              } mx-1.5`}
                            ></div>
                            <div className="flex items-center gap-2">
                              <div
                                className={`px-2.5 py-1 ${
                                  isDarkMode
                                    ? "bg-gray-700 border-gray-600"
                                    : "bg-white border-gray-200"
                                } border rounded-md flex items-center gap-1.5 shadow-sm`}
                              >
                                <svg
                                  className={`w-4 h-4 ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-500"
                                  }`}
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                  />
                                </svg>
                                <span
                                  className={`text-sm font-mono font-medium ${
                                    isDarkMode
                                      ? "text-gray-300"
                                      : "text-gray-700"
                                  }`}
                                >
                                  {formatTime(time)}
                                </span>
                              </div>

                              {/* Timer Controls */}
                              <div className="flex items-center gap-1.5">
                                {!timerRunning ? (
                                  <button
                                    onClick={startTimer}
                                    className={`p-1.5 rounded-md ${
                                      isDarkMode
                                        ? "bg-emerald-900 text-emerald-300 border-emerald-700 hover:bg-emerald-800"
                                        : "bg-emerald-50 text-emerald-600 border-emerald-200 hover:bg-emerald-100"
                                    } border transition-colors`}
                                    title="Start Timer"
                                  >
                                    <svg
                                      className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M8 5v14l11-7z" />
                                    </svg>
                                  </button>
                                ) : (
                                  <button
                                    onClick={pauseTimer}
                                    className={`p-1.5 rounded-md ${
                                      isDarkMode
                                        ? "bg-amber-900 text-amber-300 border-amber-700 hover:bg-amber-800"
                                        : "bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-100"
                                    } border transition-colors`}
                                    title="Pause Timer"
                                  >
                                    <svg
                                      className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                                    </svg>
                                  </button>
                                )}
                                <button
                                  onClick={resetTimer}
                                  className={`p-1.5 rounded-md ${
                                    isDarkMode
                                      ? "bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600"
                                      : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                                  } border transition-colors`}
                                  title="Reset Timer"
                                >
                                  <svg
                                    className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={formatSQLQuery}
                              className="px-2 py-1 bg-white text-gray-700 text-sm font-medium rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 flex items-center gap-1.5"
                            >
                              <svg
                                className="w-3.5 h-3.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M4 6h16M4 12h16m-7 6h7"
                                />
                              </svg>
                              Format
                            </button>
                            <button
                              onClick={clearSQLQuery}
                              className="px-2 py-1 bg-white text-gray-700 text-sm font-medium rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 flex items-center gap-1.5"
                            >
                              <svg
                                className="w-3.5 h-3.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                              Clear
                            </button>
                            <button
                              onClick={handleEditorExpand}
                              className={`p-1.5 ${
                                isDarkMode
                                  ? "hover:bg-gray-600"
                                  : "hover:bg-gray-200"
                              } rounded-lg transition-colors`}
                            >
                              <svg
                                className={`w-4 h-4 ${
                                  isDarkMode ? "text-gray-300" : "text-gray-600"
                                }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>

                        {/* Editor Content */}
                        <div className="flex flex-col h-[calc(100%-48px)]">
                          <CodeMirror
                            className="h-full overflow-auto"
                            value={sqlQuery}
                            onChange={handleQueryChange}
                            extensions={[
                              sql({ dialect }),
                              cursorPositionExtension,
                            ]}
                            theme="light"
                            basicSetup={{
                              lineNumbers: true,
                              highlightActiveLineGutter: true,
                              highlightSpecialChars: true,
                              foldGutter: true,
                              dropCursor: true,
                              allowMultipleSelections: true,
                              indentOnInput: true,
                              bracketMatching: true,
                              closeBrackets: true,
                              autocompletion: true,
                              rectangularSelection: true,
                              crosshairCursor: true,
                              highlightActiveLine: true,
                              highlightSelectionMatches: true,
                              closeBracketsKeymap: true,
                              defaultKeymap: true,
                              searchKeymap: true,
                              historyKeymap: true,
                              foldKeymap: true,
                              completionKeymap: true,
                              lintKeymap: true,
                            }}
                          />
                        </div>

                        {/* Resize Handle with Visual Indicator */}
                        <div
                          ref={resizeRef}
                          className="absolute bottom-0 right-0 w-6 h-6 cursor-se-resize group"
                          onMouseDown={handleResizeStart}
                          title="Drag to resize"
                        >
                          <div className="absolute bottom-0 right-0 w-6 h-6 flex items-end justify-end p-1">
                            <div className="relative">
                              <div className="absolute bottom-[8px] right-[8px] w-[2px] h-[8px] bg-gray-400 transform rotate-45 group-hover:bg-gray-600 transition-colors"></div>
                              <div className="absolute bottom-[4px] right-[4px] w-[2px] h-[8px] bg-gray-400 transform rotate-45 group-hover:bg-gray-600 transition-colors"></div>
                              <div className="absolute bottom-0 right-0 w-[2px] h-[8px] bg-gray-400 transform rotate-45 group-hover:bg-gray-600 transition-colors"></div>
                            </div>
                          </div>
                          <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity bg-gray-800 text-white text-xs rounded px-2 py-1 pointer-events-none">
                            Drag to resize
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Action Bar */}
                  <div
                    className={`backdrop-blur-sm ${
                      isDarkMode
                        ? "bg-gray-800/70 border-gray-600/50"
                        : "bg-white/70 border-gray-200/50"
                    } shadow-lg px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-b-lg`}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 sm:gap-2">
                      {/* Status Messages Container with Responsive Height */}
                      <div className="flex-1 mr-0 sm:mr-3 md:mr-4 min-h-[28px] sm:min-h-[36px] md:min-h-[40px] relative">
                        <div className="absolute inset-0 w-full h-full flex items-center">
                          {isButtonDisabled ? (
                            <div
                              className={`w-full flex items-center space-x-2 ${
                                isDarkMode
                                  ? "bg-blue-900/80 border-blue-700/70"
                                  : "bg-blue-50/80 border-blue-200/70"
                              } backdrop-blur-sm p-1.5 sm:p-2 rounded-lg border shadow-inner`}
                            >
                              <div className="animate-spin rounded-full h-3 w-3 sm:h-4 sm:w-4 border-b-2 border-blue-600"></div>
                              <span
                                className={`text-xs sm:text-sm ${
                                  isDarkMode ? "text-blue-300" : "text-blue-700"
                                } font-medium`}
                              >
                                Processing query...
                              </span>
                            </div>
                          ) : (
                            <div className="w-full text-xs sm:text-sm">
                              {submissionResult?.success && (
                                <div
                                  className={`flex items-center space-x-2 p-1.5 sm:p-2 rounded-lg backdrop-blur-sm shadow-inner ${
                                    submissionResult.isCorrect
                                      ? isDarkMode
                                        ? "bg-gradient-to-r from-green-900/80 to-emerald-900/80 text-green-300 border border-green-700/70"
                                        : "bg-gradient-to-r from-green-50/80 to-emerald-50/80 text-green-700 border border-green-200/70"
                                      : isDarkMode
                                      ? "bg-gradient-to-r from-red-900/80 to-rose-900/80 text-red-300 border border-red-700/70"
                                      : "bg-gradient-to-r from-red-50/80 to-rose-50/80 text-red-700 border border-red-200/70"
                                  }`}
                                >
                                  <svg
                                    className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d={
                                        submissionResult.isCorrect
                                          ? "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                          : "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                      }
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  <span className="font-medium truncate">
                                    {submissionResult.feedback}
                                  </span>
                                </div>
                              )}

                              {queryerror && (
                                <div
                                  className={`p-1.5 sm:p-2 ${
                                    isDarkMode
                                      ? "bg-gradient-to-r from-red-900/80 to-rose-900/80 text-red-300 border-red-700/70"
                                      : "bg-gradient-to-r from-red-50/80 to-rose-50/80 text-red-700 border-red-200/70"
                                  } backdrop-blur-sm border rounded-lg shadow-inner`}
                                >
                                  <div className="flex items-center space-x-2">
                                    <svg
                                      className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    <p className="text-xs sm:text-sm font-medium truncate">
                                      {queryerror}
                                    </p>
                                  </div>
                                </div>
                              )}

                              {!isButtonDisabled &&
                                !submissionResult?.success &&
                                !queryerror && (
                                  <div
                                    className={`p-1.5 sm:p-2 ${
                                      isDarkMode
                                        ? "bg-gray-700/80 text-gray-300 border-gray-600/70"
                                        : "bg-gray-50/80 text-gray-500 border-gray-200/70"
                                    } backdrop-blur-sm border rounded-lg shadow-inner`}
                                  >
                                    <p className="text-xs sm:text-sm font-medium">
                                      Ready to execute or submit your query
                                    </p>
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Action Buttons with Glass Effect */}
                      <div className="flex items-center space-x-2 flex-shrink-0">
                        <button
                          onClick={executeQuery}
                          disabled={isButtonDisabled}
                          className="px-2.5 sm:px-3 py-1 sm:py-1.5 bg-gradient-to-r from-gray-700/90 to-gray-800/90 backdrop-blur-sm text-white text-[10px] sm:text-xs font-medium rounded-lg 
                                                    hover:from-gray-800 hover:to-gray-900 disabled:from-gray-400/80 disabled:to-gray-500/80 
                                                    transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_15px_rgba(0,0,0,0.1)]
                                                    focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2
                                                    flex items-center space-x-1.5 shadow-sm hover:shadow-md border border-gray-700/20"
                        >
                          <svg
                            className="w-3 h-3 sm:w-3.5 sm:h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <span>Execute</span>
                        </button>

                        <button
                          onClick={submitQuery}
                          disabled={isButtonDisabled}
                          className="px-2.5 sm:px-3 py-1 sm:py-1.5 bg-gradient-to-r from-blue-500/90 to-blue-600/90 backdrop-blur-sm text-white text-[10px] sm:text-xs font-medium rounded-lg 
                                                    hover:from-blue-600 hover:to-blue-700 disabled:from-blue-400/80 disabled:to-blue-500/80 
                                                    transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_15px_rgba(59,130,246,0.3)]
                                                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                                                    flex items-center space-x-1.5 shadow-sm hover:shadow-md border border-blue-500/20"
                        >
                          <svg
                            className="w-3 h-3 sm:w-3.5 sm:h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <span>Submit</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Section: Results View */}
                <div
                  className={`flex flex-col h-full ${
                    isDarkMode
                      ? "bg-gray-800 border-gray-600"
                      : "bg-white border-gray-200"
                  } border rounded-lg shadow-sm`}
                >
                  <div
                    className={`flex-1 overflow-hidden ${
                      isDarkMode
                        ? "bg-gradient-to-b from-gray-700/80 to-gray-800/90 border-gray-600"
                        : "bg-gradient-to-b from-gray-50/80 to-white/90 border-gray-100"
                    } backdrop-blur-sm p-1 sm:p-2 border rounded-md`}
                  >
                    {results ? (
                      viewMode === "table" ? (
                        <div
                          className={`h-full overflow-auto rounded-md shadow-sm ${
                            isDarkMode
                              ? "bg-gray-800/70 border-gray-600/50 hover:border-blue-600/50"
                              : "bg-white/70 border-gray-100/50 hover:border-blue-100/50"
                          } backdrop-blur-md border transition-all duration-300 hover:shadow-lg`}
                        >
                          <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-500/90 to-indigo-500/90 backdrop-blur-md px-3 py-2 flex items-center justify-between">
                            <h3 className="text-sm font-medium text-white flex items-center">
                              <svg
                                className="w-4 h-4 mr-2 text-blue-100"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                />
                              </svg>
                              Query Results
                            </h3>

                            {/* MOVED: Toggle Buttons now in header */}
                            <div className="flex items-center gap-2">
                              {/* Table/Chart Toggle */}
                              <div className="flex bg-white/20 p-0.5 rounded-md border border-white/30">
                                <button
                                  onClick={() => setViewMode("table")}
                                  className={`px-2 py-0.5 rounded-md flex items-center gap-1 text-[10px] font-medium transition-all duration-200 ${
                                    viewMode === "table"
                                      ? "bg-white text-blue-600 shadow-sm"
                                      : "text-white hover:bg-white/10"
                                  }`}
                                >
                                  <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                  </svg>
                                  <span>Table</span>
                                </button>
                                <button
                                  onClick={() => setViewMode("chart")}
                                  className={`px-2 py-0.5 rounded-md flex items-center gap-1 text-[10px] font-medium transition-all duration-200 ${
                                    viewMode === "chart"
                                      ? "bg-white text-blue-600 shadow-sm"
                                      : "text-white hover:bg-white/10"
                                  }`}
                                >
                                  <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                                    />
                                  </svg>
                                  <span>Chart</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="p-0.5">
                            <DataTable data={results} isDarkMode={isDarkMode} />
                          </div>
                        </div>
                      ) : (
                        <div
                          className={`h-full overflow-auto rounded-md shadow-sm ${
                            isDarkMode
                              ? "bg-gray-800/70 border-gray-600/50 hover:border-purple-600/50"
                              : "bg-white/70 border-gray-100/50 hover:border-purple-100/50"
                          } backdrop-blur-md border transition-all duration-300 hover:shadow-lg`}
                        >
                          <div className="sticky top-0 z-10 bg-gradient-to-r from-purple-500/90 to-indigo-500/90 backdrop-blur-md px-3 py-2 flex items-center justify-between">
                            <h3 className="text-sm font-medium text-white flex items-center">
                              <svg
                                className="w-4 h-4 mr-2 text-purple-100"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                                />
                              </svg>
                              Chart Visualization
                            </h3>

                            {/* MOVED: Toggle Buttons now in header */}
                            <div className="flex items-center gap-2">
                              {/* Table/Chart Toggle */}
                              <div className="flex bg-white/20 p-0.5 rounded-md border border-white/30">
                                <button
                                  onClick={() => setViewMode("table")}
                                  className={`px-2 py-0.5 rounded-md flex items-center gap-1 text-[10px] font-medium transition-all duration-200 ${
                                    viewMode === "table"
                                      ? "bg-white text-purple-600 shadow-sm"
                                      : "text-white hover:bg-white/10"
                                  }`}
                                >
                                  <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                  </svg>
                                  <span>Table</span>
                                </button>
                                <button
                                  onClick={() => setViewMode("chart")}
                                  className={`px-2 py-0.5 rounded-md flex items-center gap-1 text-[10px] font-medium transition-all duration-200 ${
                                    viewMode === "chart"
                                      ? "bg-white text-purple-600 shadow-sm"
                                      : "text-white hover:bg-white/10"
                                  }`}
                                >
                                  <svg
                                    className="w-3 h-3"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                                    />
                                  </svg>
                                  <span>Chart</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="p-2">
                            <FlexibleChart data={results} />
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="h-full flex flex-col items-center justify-center">
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-800/80 border-gray-600/50 hover:border-blue-600/50"
                              : "bg-white/80 border-gray-100/50 hover:border-blue-100/50"
                          } backdrop-blur-md rounded-xl p-6 shadow-sm border max-w-md w-full transform transition-all duration-300 hover:shadow-md group`}
                        >
                          <div className="flex flex-col items-center text-center">
                            <div
                              className={`w-16 h-16 ${
                                isDarkMode
                                  ? "bg-gradient-to-br from-blue-900 to-indigo-900 border-blue-700/50"
                                  : "bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-100/50"
                              } rounded-full flex items-center justify-center mb-4 border shadow-inner group-hover:shadow-md group-hover:scale-105 transition-all duration-300`}
                            >
                              <svg
                                className={`w-8 h-8 ${
                                  isDarkMode
                                    ? "text-blue-400/80"
                                    : "text-blue-500/80"
                                }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.5"
                                  d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7c0-2-1-3-3-3H7C5 4 4 5 4 7z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.5"
                                  d="M10 14L8 12L10 10"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.5"
                                  d="M14 10L16 12L14 14"
                                />
                              </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                              No Results Yet
                            </h3>
                            <p className="text-gray-600 mb-4">
                              Execute a query to see your results displayed
                              here. You can view data in both table and chart
                              formats.
                            </p>
                            <div className="inline-flex items-center text-sm text-blue-600 bg-blue-50/50 px-3 py-1.5 rounded-full border border-blue-100/50">
                              <svg
                                className="w-4 h-4 mr-1.5 animate-pulse"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M13 10V3L4 14h7v7l9-11h-7z"
                                />
                              </svg>
                              Click "Execute" to run your query
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Split>
            </div>
          </div>
        </Split>
      </div>

      {/* Query History Panel - Rendered at document level */}
      {showQueryHistory && (
        <div
          ref={queryHistoryRef}
          className="fixed z-[99999] w-80 bg-white rounded-lg shadow-2xl border border-gray-200 max-h-96 overflow-hidden"
          style={{
            top: `${queryHistoryButtonPosition.top}px`,
            right: `${queryHistoryButtonPosition.right}px`,
          }}
        >
          <div className="bg-blue-50 border-b border-blue-100 px-4 py-2 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <RiHistoryLine className="text-blue-500" />
              <h3 className="text-sm font-medium text-gray-700">
                Query History
              </h3>
            </div>
            <button
              onClick={() => setShowQueryHistory(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="overflow-y-auto max-h-80">
            {queryHistory.length === 0 ? (
              <div className="p-4 text-center text-gray-500 text-sm">
                No query history yet
              </div>
            ) : (
              <ul className="divide-y divide-gray-100">
                {queryHistory.map((item, index) => (
                  <li
                    key={index}
                    className={`p-3 hover:bg-gray-50 cursor-pointer ${
                      item.successful
                        ? "border-l-2 border-green-500"
                        : "border-l-2 border-red-500"
                    }`}
                    onClick={() => loadQueryFromHistory(item)}
                  >
                    <div className="flex justify-between items-start mb-1">
                      <div className="text-xs text-gray-500">
                        {new Date(item.timestamp).toLocaleTimeString()}
                      </div>
                      <div
                        className={`text-xs px-1.5 py-0.5 rounded ${
                          item.successful
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {item.successful ? "Success" : "Failed"}
                      </div>
                    </div>
                    <div className="text-xs font-mono bg-gray-50 p-2 rounded whitespace-pre-wrap max-h-20 overflow-hidden">
                      {item.query.length > 150
                        ? item.query.substring(0, 150) + "..."
                        : item.query}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {/* Keyboard Shortcuts Panel - Rendered at document level */}
      {isHoveringShortcuts && (
        <div
          ref={keyboardShortcutsRef}
          className="fixed z-[99999] w-96 bg-white rounded-lg shadow-2xl border border-gray-200 overflow-hidden"
          style={{
            top: `${shortcutsButtonPosition.top}px`,
            right: `${shortcutsButtonPosition.right}px`,
          }}
          onMouseEnter={() => setIsHoveringShortcuts(true)}
          onMouseLeave={handleShortcutsMouseLeave}
        >
          <div className="bg-gray-50 border-b border-gray-200 px-4 py-2 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <FaKeyboard className="text-gray-600" />
              <h3 className="text-sm font-medium text-gray-700">
                Keyboard Shortcuts
              </h3>
            </div>
          </div>
          <div className="p-2">
            <div className="mb-2 px-3 py-1 bg-blue-50 rounded text-xs text-blue-700">
              <p>
                Note: Mac users should use{" "}
                <span className="font-semibold">⌘ Command</span> for
                Execute/Submit and{" "}
                <span className="font-semibold">⌥ Option</span> for other
                shortcuts.
              </p>
            </div>
            <ul className="divide-y divide-gray-100">
              {keyboardShortcuts.map((shortcut, index) => (
                <li key={index} className="py-2 px-3 flex items-center">
                  <span className="text-sm text-gray-700 flex-1">
                    {shortcut.description}
                  </span>
                  <div className="flex items-center space-x-2 flex-shrink-0">
                    <div className="flex items-center">
                      <span className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded font-mono whitespace-nowrap">
                        {shortcut.key}
                      </span>
                    </div>
                    <span className="text-xs text-gray-400">/</span>
                    <div className="flex items-center">
                      <span className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded font-mono whitespace-nowrap">
                        {shortcut.macKey}
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default SubscribersMain;
